import { createContext } from 'react';

import { HttpClient } from '~/services/HttpClient';
import { tokenManager } from '~/services/TokenManager';
import { createLogger } from '~/utils/logging';
import { getEnvironmentVariables } from '~/environment';

const log = createLogger('HttpClientProvider');

log.debug('Creating singleton HttpClient wired to TokenManager');
const httpClient = new HttpClient(getEnvironmentVariables().socraitApiUrl, {
  getToken: () => tokenManager.getToken(),
  resolveNewToken: () => tokenManager.refresh(),
});

export const HttpClientContext = createContext<HttpClient>(httpClient);

export const HttpClientProvider = ({ children }: { children: React.ReactNode }) => {
  return <HttpClientContext.Provider value={httpClient}>{children}</HttpClientContext.Provider>;
};
